import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import rpc from "@1games-ru/rage-rpc";
import PlayerMpProvider from "@/core/data-provider/data-mp/player/player-mp-provider.ts";
import useAppDispatch from "@/core/helpers/useAppDispatch.ts";
import { imgHomeMenuPlayer } from "@/shared/assets/img";
import { clearOffer, setOfferCreator } from "@/domains/offer/slice.ts";
import toast from "@/domains/toasts/helpers/toast.ts";

export default () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("offer");

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Offer.OfferCreatorShow,
      async (state: typeof RegionShared.Cef.Requests.OfferCreatorShowRequest): Promise<void> => {
        const character = await PlayerMpProvider.getCharacter(state.targetCharacterId);

        if (!character) {
          toast.error(t("offer.errors.CAN_NOT_FIND_CHARACTER"));
          console.error("Character not found");
          return;
        }

        dispatch(
          setOfferCreator({
            type: state.type,
            creator: {
              targetCharacter: {
                id: character.id,
                name: character.name.content,
                avatar: imgHomeMenuPlayer,
              },
            },
          }),
        );
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Offer.OfferCreatorShow);
    };
  }, [dispatch, t]);

  useLayoutEffect(() => {
    rpc.register(RegionShared.Cef.Events.Offer.OfferCreatorHide, async (): Promise<void> => {
      dispatch(clearOffer());
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Offer.OfferCreatorHide);
    };
  }, [dispatch, t]);
};
